module.exports = __webpack_public_path__ + "media/images/flags/be-5b3a82a296b071e1440a4b997dd4c391.svg";